export default class Url {

    /**
     * Url constructor.
     *
     * @param {string} url
     */
    constructor(url) {
        this.url = url;
        this.parameters = [];
        this.cleanUrl = '';
    }

    /**
     * Get the url without parameters
     *
     * @return {string}
     */
    getWithoutParameters() {
        let pos;
        this.cleanUrl = this.url;

        if ((pos = this.url.indexOf('?')) !== -1) {
            this.cleanUrl = this.url.substr(0, pos);
        }

        return this.cleanUrl;
    }

    /**
     * Build a url parameter
     *
     * @param {string} name
     *
     * @param {string} value
     */
    buildParameter(name, value) {
        return `${name}=${value}`;
    }

    /**
     * Return true if url has the parameter
     *
     * @returns {boolean}
     */
    hasParameter(parameter) {
        return this.url.includes(this.buildParameter(parameter, ''));
    }

    /**
     * Get the url parameters array
     *
     * @return {string[]}
     */
    getParameters() {
        let pos;

        if ((pos = this.url.indexOf('?')) !== -1) {
            const urlParameters = this.url.substr(pos + 1);
            const params = urlParameters.split('&');

            for (let param of params) {
                const nameValue = param.split('=');
                this.setParameter(nameValue[0], nameValue[1]);
            }
        }

        return this.parameters;
    }

    /**
     * Set parameter to url
     *
     * @param {string} name
     * @param {string} value
     */
    setParameter(name, value) {
        const parameter = this.buildParameter(name, '');

        for (let [i, param] of this.parameters) {
            if (param.includes(parameter)) {
                this.parameters[i] = this.buildParameter(name, value);
                return;
            }
        }

        this.parameters.push(this.buildParameter(name, value));
    }

    /**
     * Is valid url
     *
     * @return {boolean}
     */
    isValid() {
        const regex = /^(((https|http):\/\/)|\/)(.+)/;

        return regex.test(this.url);
    }

    /**
     * Get the url string
     *
     * @return {string}
     */
    toString() {
        let url = this.getWithoutParameters();
        const parameters = this.getParameters();

        if (parameters.length > 0) {
            url += '?' + parameters.join('&');
        }

        return url;
    }

}